export const SWAG_BUNDLES_ADMIN_PREFIX = 'SWAG_BUNDLES_';
export const SWAG_BUNDLES_RESET = `${SWAG_BUNDLES_ADMIN_PREFIX}_RESET`;
export const SWAG_BUNDLE_SKIP_STEP = `${SWAG_BUNDLES_ADMIN_PREFIX}_SKIP_STEP`;
export const resetSwagBundles = () => ({
  type: SWAG_BUNDLES_RESET
});
export const skipSwagBundlesStep = step => ({
  type: SWAG_BUNDLE_SKIP_STEP,
  payload: step
});